/* eslint-disable */
import { Col, Row } from 'antd';
import { Column, Space, Text } from 'farmhub-ui-core';
import * as React from 'react';

import ObjectSelect from 'components/Form/ObjectSelect';
import { TEMPLATE } from 'utils';

import { Wrapper } from './styles';
import EntityCardItem from '../EntityCardItem';

interface ListAccountProps {
  entities: any[];
  handleClickEntity: (e: string) => void;
  isAtModal?: boolean;
}

const ListAccountDesktop = ({
  entities,
  isAtModal,
  handleClickEntity,
}: ListAccountProps): JSX.Element => {
  const [template, setTemplate] = React.useState<any>(TEMPLATE[0]);

  return (
    <Wrapper>
      {
        !isAtModal && (
          <>
            <Column styles={{ gap: 6 }} alignItems="center">
              <Text size="lg" weight="extraBold" color="dark">
                Tạo thực thể
              </Text>
              <Text
                color="secondary"
                styles={{ width: 520, display: 'block', textAlign: 'center' }}
              >
                Vui lòng lựa chọn thực thể bạn muốn tạo để khám phá các tính năng truy xuất, liên kết, mua bán, quản lý và nhiều hơn thế nữa.
              </Text>
            </Column>
            <Space height={36} />
          </>

        )
      }

      <Text size={isAtModal ? 'xs' : "sm"} weight="bold" color="dark">
        Mẫu giải pháp ({TEMPLATE.length}):
      </Text>
      <Space height={18} />
      <ObjectSelect
        amountItem={isAtModal ? 6 : 8}
        objectTypeActive={template.code}
        onSelect={(val: string) => {
          setTemplate(TEMPLATE.find((item: any) => item.code == val));
        }}
      />
      <Space height={24} />
      <Text size={isAtModal ? 'xs' : "sm"} weight="bold" color="dark">
        Chọn thực thể muốn tạo:
      </Text>
      <Space height={18} />
      <Row gutter={[18, 18]}>
        {entities.filter((filterItem: any) => template.types.includes(filterItem.type)).map((item: any, index: number) => (
          <Col key={index} span={12}>
            <EntityCardItem
              disabled={item?.disabled}
              item={item}
              onClick={() => !item?.disabled && handleClickEntity(item.type)}
            />
          </Col>
        ))}
      </Row>
      <Space height={36} />
    </Wrapper>
  );

}
export default ListAccountDesktop;
